import { ScreeningSurveyAttributesSchema } from "@clipboard-health/contract-home-health-api";
import { z } from "zod";

export const screeningSurveyFormSchema = ScreeningSurveyAttributesSchema.extend({
  emrSystems: z.array(z.string()).min(1),
  languages: z.array(z.string()).min(1),
  specialtyCareExperience: z.array(z.string()).min(1),
  whyHealthcare: z.string().min(10),
});

export type ScreeningSurveyFormData = z.infer<typeof screeningSurveyFormSchema>;
